import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider, } from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { Pagination } from "../../../_metronic/_partials/controls";
import * as columnFormatters from "../../components/column-formatters";
import * as UIHelpers from "../../components/UIHelpers";
import DeleteDialog from "../../components/DeleteDialog";
import FilterComponent from "../../components/FilterComponent";
import {
    NotificationManager,
    NotificationContainer,
  } from "react-notifications";
import { Formik, Field } from "formik";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import {
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret,
    headerSortingClasses,
} from "../../../_metronic/_helpers";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import helperFunc from "../../../_metronic/_helpers/helperFunc";


export const initialFilter = {
    filter: {},
    q: '',
    sort: "desc", // asc||desc
    sortBy: "createdAt",
    skip: UIHelpers.skip,
    limit: UIHelpers.limit,
    page: UIHelpers.page,
};

const ListComponent = (props) => {
    const dispatch = useDispatch();
    const suhbeader = useSubheader();
    const [filter, setFilter] = useState(initialFilter);
    const [count, setCount] = useState(0);
    const [searchApply, setSearchApply] = useState(false);
    const [isDeleteShow, setIsDeleteShow] = useState(false);
    const [deleteItemRow, setDeleteItemRow] = useState(undefined);
    const [
        contestForSelectedDropdownFilterData,
        setContestForListDropdownFilterData,
      ] = useState([]);
      const [
        contestForDropdownFilterData,
        setContestForDropdownFilterData,
      ] = useState([]);
    suhbeader.setTitle("Html5 Games");
    suhbeader.setIsSearch(true);
    useEffect(() => {
        filter.q = suhbeader.searchText.q
        setFilter(filter);
        setCount(count + 1);
    }, [suhbeader.searchText]);

    const newItem = () => {
        props.history.push("/H5Games/create");
    }
    const editItem = (id) => {
        props.history.push(`/H5Games/edit/${id}`);
    }

    const deleteItem = () => {
      const id = deleteItemRow && deleteItemRow._id;
      dispatch(actions.deleteItem(id)).then(() => {
          // After successful deletion, fetch the list again
          dispatch(actions.fetchList(filter));
          hideDeleteConfirm();
      });
  };
  
    const hideDeleteConfirm = () => {
        setIsDeleteShow(false);
        setDeleteItemRow(undefined);
    }
    const deleteItemConfirm = (row) => {
        setIsDeleteShow(true);
        setDeleteItemRow(row);
    }
    const getHandlerTableChange = (type, data) => {
      if (type === "pagination") {
          setFilter(prevFilter => ({
              ...prevFilter,
              limit: data.sizePerPage,
              skip: Math.abs(data.page ? data.sizePerPage - data.page * data.sizePerPage : 0),
              page: data.page || 1,
          }));
          // Remove the setCount line if you don't want to increment count on pagination changes
  
          // Call the fetchList API here
          if (!listLoading) {
              dispatch(actions.fetchList({
                  ...filter,
                  limit: data.sizePerPage,
                  skip: Math.abs(data.page ? data.sizePerPage - data.page * data.sizePerPage : 0),
                  page: data.page || 1,
              }));
          }
      }
      if (type === "sort") {
          setFilter(prevFilter => ({
              ...prevFilter,
              sort: data.sortOrder,
              sortBy: data.sortField,
          }));
          setCount(count + 1);
  
          // Call the fetchList API here if needed
          // Example:
          // if (!listLoading) {
          //     dispatch(actions.fetchList(filter));
          // }
      }
      // Other conditions for different table changes...
  };
  
    const filterChange = (filterData) => {
        filter.q = filterData.q;
        filter.filter = filterData.filter;
        setFilter(filter);
        setCount(count + 1);
    }
    const statusChange = (data) => {
        let params = {...data} ;
        params.isActive = !params.isActive;
        delete params.createdAt;
        delete params.html5Category;
        if(contestForSelectedDropdownFilterData?.code){
          params.company = contestForSelectedDropdownFilterData?.code
        }else if(contestForSelectedDropdownFilterData.length >0 && contestForSelectedDropdownFilterData[0]?.code){
          params.company = contestForSelectedDropdownFilterData[0]?.code
      }
      if(contestForSelectedDropdownFilterData?.code?.toLowerCase() ==='vi'){
        dispatch(actions.updateStatus(params)).then((sucess) => {
            if(sucess){
              setCount(count+1)
            }
            dispatch(actions.fetchList(filter));
          })
      }else{
        dispatch(actions.updateItem(params)).then((sucess) => {
          if(sucess){
            setCount(count+1)
          }
          dispatch(actions.fetchList(filter));
        })}
    }
    const columns = [
        {
            dataField: "country.name",
            text: "Country",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
            hidden:!helperFunc.isCountryVisible(),
        },
        {
            dataField: "name",
            text: "Name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "html5Category.name",
            text: "Html5 Category",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "order",
            text: "Order",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "thumbImage",
            text: "Image",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.ImageColumnFormatter,
            formatExtraData: {
                dIndexName: 'thumbImage'
            },
        },
        {
            dataField: "createdAt",
            text: "CreatedAt",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.DateColumnFormatter,
        },
        {
            dataField: "isActive",
            text: "IsActive",
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.StatusColumnFormatter,
            formatExtraData: {
                statusChange:helperFunc.isButtonAccess("html5Games.gamesList.update") ? statusChange : null,
            },
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                editItem: helperFunc.isButtonAccess("html5Games.gamesList.update")?editItem:null,
                deleteItem:helperFunc.isButtonAccess("html5Games.gamesList.update")?deleteItemConfirm :null
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];
    const { currentState } = useSelector(
        (state) => ({ currentState: state.H5Games }),
        shallowEqual
    );
    const { totalCount, entities, listLoading ,companyDropdownList} = currentState;
    useEffect(() => {

        dispatch(actions.fetchCompanyDropdownList());
    
      }, []);
      useEffect(() => {
        if (companyDropdownList && companyDropdownList?.data) {
          // let temp = [{
          //   _id: 0,
          //   label: "All",
          //   value: "all",
          //   baseUrl: "all",
          // }];
          let temp = [];
          const userdata = JSON.parse(localStorage.getItem("userData"));
          const userCompany = userdata?.company || [];
          companyDropdownList.data.forEach((element, i) => {
            // console.log(userCompany.includes(element._id));
            // console.log(!helperFunc.isAdmin());
            // if (!helperFunc.isAdmin()) {
              if (userCompany.includes(element._id)) {
                temp.push({
                  _id: i + 1,
                  label: element.name,
                  value: element._id,
                  baseUrl: element.baseUrl,
                  code:element.code,
                  "data-tokens": element.name,
                });
              }
            // } else {
            //   temp.push({
            //     _id: i + 1,
            //     label: element.name,
            //     value: element._id,
            //     baseUrl: element.baseUrl,
            //     code:element.code,
            //     "data-tokens": element.name,
            //   });
            // }
          });
          setContestForDropdownFilterData(temp);
        }
      }, [companyDropdownList]);
   // console.log("ENTITIES : : : ", entities)

    // useEffect(() => {
    //     if(!listLoading) {
    //         dispatch(actions.fetchList(filter));
    //     }
    // }, [count]);

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: UIHelpers.sizePerPageList,
        sizePerPage: filter.limit,
        page: filter.page,
    };
    const applyFilter = async (values) => {
        if (
          contestForSelectedDropdownFilterData == null ||
          contestForSelectedDropdownFilterData.length <= 0
        ) {
          NotificationManager.error("Please Select Company", "Error");
          return false;
        }
        setSearchApply(true);
        var tampFilter = { ...filter };
         tampFilter.company=contestForSelectedDropdownFilterData.code
        if (values?.phoneEmail) {
          tampFilter.search = {
            userID: values.phoneEmail,
          };
        }
        let selectedFields = [];
    
        // Add the logic to update the selectedFields array with the selected fields
    
    
    
        setFilter(tampFilter);
       
    
        console.log("tampFilter", tampFilter);
    
        if (!listLoading) {
          // dispatch(actions.fetchStaffUsers(tampFilter));
          localStorage.setItem('selectedCompany', contestForSelectedDropdownFilterData.code);
    
          dispatch(actions.fetchList(tampFilter));
        }
    
      };
      const createFormInputs = () => {
        return (
          <div
            className="report-filter-bLock border-0 row align-items-center"
            style={{ padding: "0px 0", margin: "0px", marginBottom: "40px" }}
          >
            <Formik
              initialValues={{}}
              onSubmit={(values) => {
                console.log("val::22", values);
                applyFilter(values);
              }}
            >
              {({ handleSubmit, values }) => (
                <div className="col-lg-12 col-md-12" >
                  {/* <div className="row m-0 p-0"> */}
                  <form
                    onSubmit={handleSubmit}
                    className="form form-filter w-100"
                    autoComplete="off"
                    style={{ marginTop: "10px" }}
                  >
                    <div className="form-group row m-0 align-items-center z-index: 10"  >
                      <div
                        className="col z-index: 10 !important"
                        style={{ maxWidth: "325px"  }}
                      >
                        <label>Select Company</label>
                        <DropdownReactSelect
                          placeholder={"Company"}
                          name={"Company"}
                          value={contestForSelectedDropdownFilterData}
                          // isMulti={values.isShared == 'true' ? true : false}
                          isMulti={false}
                          isClearable={true}
                          isSearchable={true}
                          closeMenuOnSelect={true}
                          options={contestForDropdownFilterData}
                          onChange={setContestForListDropdownFilterData}
                        />
                      </div>
    
                      <div className="justify-content-end mx-2">
                        <button
                          type="submit"
                          className="btn btn-dark"
                          style={{ width: "130px", marginTop: "20px" }}
                        >
                          Search
                        </button>
    
                      </div>
    
                    </div>
    
                  </form>
                  {/* </div> */}
                </div>
              )}
            </Formik>
    
          </div>
        );
      };
    return (
        <>
            <DeleteDialog
                show={isDeleteShow}
                name={deleteItemRow && deleteItemRow.name}
                item={deleteItemRow}
                onDelete={deleteItem}
                onHide={hideDeleteConfirm}
            />
            <Card>
            <NotificationContainer />
                <CardHeader title="Html5 Games list">
                    <CardHeaderToolbar>
                        {helperFunc.isButtonAccess("html5Games.gamesList.add") && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={newItem}
                            >New Html5 Game</button>
                        )}
                    </CardHeaderToolbar>
                </CardHeader>
                {createFormInputs()}
                {searchApply === true ? ( // searchApply === true
          entities?.length == 0 && listLoading === false ? (
            UIHelpers.dataTableNoData()
          ) : (
                <CardBody>
                    <FilterComponent filterChange={filterChange} />
                    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                        {({ paginationProps, paginationTableProps }) => {
                            return (
                                <Pagination
                                    isLoading={listLoading}
                                    paginationProps={paginationProps}
                                >
                                    <BootstrapTable
                                        wrapperClasses="table-responsive"
                                        bordered={false}
                                        classes="table table-head-custom table-vertical-center overflow-hidden"
                                        bootstrap4
                                        remote
                                        keyField="_id"
                                        data={entities ? entities : []}
                                        columns={columns}
                                        onTableChange={getHandlerTableChange}
                                        // selectRow={getSelectRow({
                                        //     entities,
                                        //     ids: customersUIProps.ids,
                                        //     setIds: customersUIProps.setIds,
                                        // })}
                                        {...props}
                                        {...paginationTableProps}
                                    >
                                        <PleaseWaitMessage entities={entities} />
                                        <NoRecordsFoundMessage entities={entities} />
                                    </BootstrapTable>
                                </Pagination>
                            );
                        }}
                    </PaginationProvider>
                </CardBody>
                    )
                    ) : (
                      // <h4 className="text-center">Please select search</h4>
                      ""
                    )}
            </Card>
        </>
    )
}
export default ListComponent;